module.exports = __webpack_public_path__ + "static/media/emy_bg_input.bf943f88.png";